import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class KitFileService extends BaseService {

    static url = "kit_files";
    static apis = {
        delete: ""
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("kit_files");
    }

}

export default KitFileService;